import cookieManager from '../common/cookieManager'
import utils from '../common/utils'

export default {
  state: {
    token: '',
    userimg: '',
    username: '',
    /** H5：登录页 getH5MpBindInfo 返回的服务企业名称 */
    customerName: '',
    /** H5：登录 User.roles / rolename */
    userRoles: '',
    themeAside: null
  },
  mutations: {
    setToken(state, val) {
      state.token = val
      const encryptedToken = utils.encryptKey(val)
      cookieManager.set('token', encryptedToken)
    },
    clearToken(state) {
      state.token = ''
      state.equser = []
      state.username = ''
      state.userimg = ''
      state.customerName = ''
      state.userRoles = ''
      cookieManager.remove('token')
      cookieManager.remove('userimg')
      cookieManager.remove('username')
      cookieManager.remove('customerName')
      cookieManager.remove('userRoles')
    },
    getToken(state) {
      const encryptedToken = cookieManager.get('token')
      if (encryptedToken) {
        state.token = utils.decryptKey(encryptedToken)
      }
    },
    setUserimg(state, val) {
      state.userimg = val
      cookieManager.set('userimg', val)
    },
    getUserimg(state) {
      state.userimg = state.userimg || cookieManager.get('userimg')
    },
    setUsername(state, val) {
      state.username = val
      cookieManager.set('username', val)
    },
    getUsername(state) {
      state.username = state.username || cookieManager.get('username')
    },
    /** 写入绑定企业名（与登录页展示同源） */
    setCustomerName(state, val) {
      state.customerName = val != null ? String(val) : ''
      cookieManager.set('customerName', state.customerName)
    },
    getCustomerName(state) {
      state.customerName = state.customerName || cookieManager.get('customerName') || ''
    },
    setUserRoles(state, val) {
      state.userRoles = val != null ? String(val) : ''
      cookieManager.set('userRoles', state.userRoles)
    },
    getUserRoles(state) {
      state.userRoles = state.userRoles || cookieManager.get('userRoles') || ''
    },
    setThemeAside(state, theme) {
      state.themeAside = theme
      try {
        localStorage.setItem('theme.aside', JSON.stringify(theme || {}))
      } catch (e) {}
    }
  }
}
